import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import ReactNotification  from 'react-notifications-component';

import { Container, Row, Col } from 'react-bootstrap'

import MainNavbar from "./components/layout/MainNavbar/MainNavbar";
import MainSidebar from "./components/layout/MainSidebar/MainSidebar";


import AppRouterPrivateDashboardRoutes from './AppRouterPrivateDashboardRoutes'

const AppScaffolding = () => {

    console.log("Enter into AppScaffolding.js");

    return (
    <>
        {/* <ApplicationContext/> */}
            <ReactNotification />
            <Container fluid>
                <BrowserRouter>
                    {/* <I18n translations={translations} useReducer={false}> */}
                    {/* <I18n translations={translations}> */}
                    <Row>
                        <MainSidebar />
                        <Col
                        className="main-content p-0"
                        lg={{ size: 10, offset: 2 }}
                        md={{ size: 9, offset: 3 }}
                        sm="12"
                        tag="main">

                        <MainNavbar />
                        <div className="content-app">
                            <AppRouterPrivateDashboardRoutes />
                        </div>
                        </Col>
                    </Row>
                    {/* </I18n> */}
                </BrowserRouter>
            </Container> 
        </>
    )
}

export default AppScaffolding;